import type { ViewConfigTreeNode } from '@salescore/core'
import { Array, Filter, pipe } from 'effect'
import { isUndefined } from 'effect/Predicate'

const getRecursiveChildren = (tree: ViewConfigTreeNode): ViewConfigTreeNode[] => [
  tree,
  ...(tree.children?.flatMap(getRecursiveChildren) ?? []),
]

/**
 * ルートを除く子孫ノードを、結合フィルタを設定済みのノードと、まだ設定していない (追加できる) ノードに分ける
 */
export const partitionJoinFilterNodes = (
  tree: ViewConfigTreeNode | undefined,
): {
  joinFiltersNodes: ViewConfigTreeNode[]
  availableJoinFiltersNodes: ViewConfigTreeNode[]
} => {
  const [availableJoinFiltersNodes, joinFiltersNodes] = pipe(
    tree?.children ?? [],
    Array.flatMap(getRecursiveChildren),
    Array.partition(Filter.fromPredicate((child) => isUndefined(child.additionalJoinOn))),
  )
  return { joinFiltersNodes, availableJoinFiltersNodes }
}
